import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatTrailerTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatTrailerType',
})
export class FormatTrailerTypePipe implements PipeTransform {
  /**
   * Takes a job's trailertype values array and displays a human-readable string
   */
  transform(value: Array<string>, ...args) {
    let trailerTypes = {
      dryVan: 'Dry Van',
      reefer: 'Refrigerated (Reefer)',
      flatbed: 'Flatbed',
      tanker: 'Tanker',
      doubtrip: 'Doubles / Triples',
      intermodal: 'Intermodal',
      hhg: 'Household Goods',
      hazmat: 'Hazmat',
      specialized: 'Specialized',
      hauler: 'Auto Hauler',
      doublepups: 'Double Pups',
      dryBulk: 'Dry Bulk & Pneumatic',
      // other:        'Other'  -- deprecated
    };
    let s = '';

    _.each(value, tt => {
      if (s) {
        s += ', ';
      }
      s += trailerTypes[tt] || '';
    });

    if (!s) {
      return 'Call to Discuss';
    } else {
      return s;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-trailer-type/format-trailer-type.ts